export default __webpack_public_path__ + "static/media/img_fee_55.74559f1f.svg";